import Label from '../../../../../ui/label';
import { useDispatch } from 'react-redux';
import { setSelectedUniformCoverage } from '../../../../../../features/gms-proposal-forms/coverage/uniform-coverage/coverage-type-uniform-coverage.slice';
import { useEffect } from 'react';
import { formatAmountType } from '../../../../../../utils/format-numbers.utils';
import Input from '../../../../../ui/input';
import { customStyle, defaultStyle } from '../../../../../../constant/custom-style';
import { useProposalTypeData } from '../../../../../../hooks/proposal/use-proposal-type-data';

export default function UniformCoverage() {

    const dispatch = useDispatch()
    const { inputsByUniformCoverage, coverage, } = useProposalTypeData()

    useEffect(() => {
        if (coverage && !inputsByUniformCoverage) {
            dispatch(setSelectedUniformCoverage({
                    label: coverage.name,
                    value: "",
                })
            );
        }
    }, [coverage, inputsByUniformCoverage, dispatch]);

    const handleChange = (value: string) => {
        if (!coverage) return;
        dispatch(setSelectedUniformCoverage({
                label: coverage.name,
                value,
        }));
    };

    const fAmount = inputsByUniformCoverage?.fAmount ?? 0

    return (

        <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
            {/* HEADER */}
            <div className="flex flex-col gap-3 border-b border-[#186cb2]/20 bg-[#186cb2]/10 px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
                {/* TITLE & DESCRIPTION */}
                <div className="min-w-0 flex-1">
                    <Label
                        label={coverage?.name ?? ""}
                        fontWeight="font-semibold text-gray-800"
                        fontSize="text-xs"
                    />
                    <p className="mt-0.5 text-[10px] leading-4 text-gray-500 sm:text-[11px]">
                        Enter a single coverage amount that will be applied
                        uniformly to all eligible members.
                    </p>
                </div>
            </div>

            {/* INPUT */}
            <div className='bg-white p-2'>
                <div>
                    <Label
                        label='Coverage Amount'
                        fontSize='text-xs mb-1'
                        requiredText=' *'
                        isRequired={true}
                    />
                    <Input
                        type='text'
                        name='uniformCoverageAmount'
                        value={formatAmountType(fAmount)}
                        isCustomStyle={true}
                        customCss={`${defaultStyle} ${!fAmount ? '' : customStyle}`}
                        onChange={(e) => handleChange(e.target.value)}
                        required={true}
                        placeholder='Enter coverage amount'
                    />
                </div>
            </div>
        </div>
    );
}
